import {
  requiredValidator,
  isEmailValidValidator,
  minLengthValidator,
  maxLengthValidator
} from 'modules/Forms/helpers/fieldValidation';
import { FIELDS_RENDER_METHOD } from 'modules/Forms/constants/FieldsRenderMethod.constants';

export const NON_CUSTOMER_FORM_FIELDS = {
  NAME: 'customerName',
  EMAIL: 'customerEmail',
}

export const NON_CUSTOMER_SUBSECTION = {
  title: 'Identificação',
  fields: [
    {
      id: NON_CUSTOMER_FORM_FIELDS.NAME,
      validators: [requiredValidator, minLengthValidator(3), maxLengthValidator(100)],
      type: 'text',
      placeholder: 'Nome *',
      renderMethod: FIELDS_RENDER_METHOD.FULL_WIDTH,
      isRequired: true,
    },
    {
      id: NON_CUSTOMER_FORM_FIELDS.EMAIL,
      validators: [requiredValidator, isEmailValidValidator, minLengthValidator(3), maxLengthValidator(100)],
      type: 'text',
      placeholder: 'E-mail para contato *',
      renderMethod: FIELDS_RENDER_METHOD.FULL_WIDTH,
      isRequired: true,
    }
  ],
};
